import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { isLogin } from '../utils';
import { setUrl } from '../service/Url';

const LoginRequired = () => {
    const location = useLocation();

    if (!isLogin()) {
        setUrl(location.pathname + location.search);
        return <Navigate to="/login" replace />;
    }

    return <Outlet />;
};

export default LoginRequired;
